// Shared breakpoint hooks (docs/SPEC_MOBILE_UI.md). Screens that must
// restructure for phones (not just reflow) key off the same queries as the CSS.

import { useSyncExternalStore } from "react";

/** Live media-query flag; re-renders on rotate/resize across the breakpoint. */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (cb) => {
      const mql = window.matchMedia(query);
      mql.addEventListener("change", cb);
      return () => mql.removeEventListener("change", cb);
    },
    () => window.matchMedia(query).matches,
  );
}

/** The narrow (single-column, bottom-bar) breakpoint — portrait phones. */
export function useNarrow(): boolean {
  return useMediaQuery("(max-width: 699px)");
}
